export const menus = [
  { id: 1, title: "Dashboard", name: "dashboard", url: "/" },
  { id: 2, title: "Finish", name: "finish", url: "/finish" },
  { id: 3, title: "Archive", name: "archive", url: "/archive" },
  { id: 4, title: "Setting", name: "setting", url: "/setting" },
];
